import { Children, cloneElement, useState } from 'react';

import Header from '../header';
import Footer from '../footer';

const Layout = ({ children }) => {
  const [selectedSection, setSelectedSection] = useState('');

  return (
    <>
      <Header
        selectedSection={selectedSection}
        setSelectedSection={setSelectedSection}
      />
      {Children.map(children, (child) =>
        cloneElement(child, {
          setSelectedSection: setSelectedSection,
        }),
      )}
      <Footer />
    </>
  );
};

export default Layout;
